<main>
  <div class="container" id="main-container">
    <div class="row">
      <div class="col px-lg-4">
        <app-breadcrumbs [path]="data?.path?.alias" [title]="data?.title"></app-breadcrumbs>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 px-lg-4 py-lg-2">
        <h1 data-audio="">{{ data?.title }}</h1>
        <h2 class="h4 py-2" data-audio="" *ngIf="data?.place_alternative_name">
          {{ data?.place_alternative_name }}
        </h2>
        <p>
          {{ data?.place_short_description }}
        </p>
      </div>
      <div class="col-lg-3 offset-lg-1">
        <app-social-share [url]="data?.path?.alias"></app-social-share>
        <app-actions-list [mailObject]="data?.title" [path]="data?.path?.alias"></app-actions-list>
        <div class="mt-4 mb-4" *ngIf="data?.place_tags.length > 0">
          <div class="row">
            <span class="mb-2 small">Argomenti</span>
          </div>
          <ul class="d-flex flex-wrap gap-1">
            <li *ngFor="let tag of data?.place_tags">
              <a class="chip chip-simple" [href]="tag?.path?.alias">
                <span class="chip-label">{{ tag?.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid my-3" *ngIf="data?.field_internal_image?.field_media_image">
    <div class="row">
      <figure class="figure px-0 img-full">
        <img [src]="data?.field_internal_image?.field_media_image?.uri?.url" class="figure-img img-fluid"
          [alt]="data?.field_internal_image?.field_media_image?.meta?.alt" />
        <figcaption class="figure-caption text-center pt-3">
          {{ data?.field_internal_image?.field_media_image?.meta?.title }}
          <span *ngIf="data?.field_internal_image?.field_media_licence">
            - {{ data?.field_internal_image?.field_media_licence }}</span>
        </figcaption>
      </figure>
    </div>
  </div>
  <div class="container">
    <div class="container-fluid my-3" *ngIf="data.place_image?.field_media_image">
      <div class="row">
        <figure class="figure px-0 img-full">
          <img [src]="data.place_image?.field_media_image?.uri?.url" class="figure-img img-fluid"
            [alt]="data.place_image?.field_media_image?.meta?.alt" />
          <figcaption class="figure-caption text-center pt-3">
            {{ data.place_image?.field_media_image?.meta?.title }}
            <span *ngIf="data?.field_internal_image?.field_media_licence">
              - {{ data.place_image?.field_media_licence }}</span>
          </figcaption>
        </figure>
      </div>
    </div>

    <div class="row border-top border-light row-column-border row-column-menu-left">
      <aside class="col-lg-3">
        <div class="cmp-navscroll sticky-top" aria-labelledby="accordion-title-one">
          <nav class="navbar it-navscroll-wrapper navbar-expand-lg" aria-label="INDICE DELLA PAGINA"
            data-bs-navscroll="">
            <div class="navbar-custom" id="navbarNavProgress">
              <div class="menu-wrapper">
                <div class="link-list-wrapper">
                  <div class="accordion">
                    <div class="accordion-item">
                      <span class="accordion-header" id="accordion-title-one">
                        <button class="accordion-button pb-10 px-3" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapse-one" aria-expanded="true" aria-controls="collapse-one">
                          INDICE DELLA PAGINA
                          <svg class="icon icon-xs right">
                            <use href="bootstrap-italia/dist/svg/sprites.svg#it-expand"></use>
                          </svg>
                        </button>
                      </span>
                      <div class="progress">
                        <div class="progress-bar it-navscroll-progressbar" role="progressbar" aria-valuenow="0"
                          aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div>
                      </div>
                      <div id="collapse-one" class="accordion-collapse collapse show" role="region"
                        aria-labelledby="accordion-title-one">
                        <div class="accordion-body">
                          <ul class="link-list" data-element="page-index">
                            <li class="nav-item" *ngIf="data?.place_long_description?.processed">
                              <a class="nav-link active" href="javascript:void(0);" data-focus-mouse="false"
                                (click)="scrollTo('descrizione')">
                                <span class="title-medium">Descrizione</span>
                              </a>
                            </li>
                            <li class="nav-item" *ngIf="data?.place_services?.processed">
                              <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('servizi')"
                                data-focus-mouse="false">
                                <span class="title-medium">Servizi presenti</span>
                              </a>
                            </li>
                            <li class="nav-item" *ngIf="data?.place_access_mode?.processed">
                              <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('accesso')"
                                data-focus-mouse="false">
                                <span class="title-medium">Modalità di accesso</span>
                              </a>
                            </li>
                            <li class="nav-item" *ngIf="data?.place_time?.processed">
                              <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('orario')"
                                data-focus-mouse="false">
                                <span class="title-medium">Orario per il pubblico</span>
                              </a>
                            </li>
                            <li class="nav-item" *ngIf="data?.place_contacts?.length > 0">
                              <a class="nav-link" href="javascript:void(0);" (click)="scrollTo('contatti')"
                                data-focus-mouse="false">
                                <span class="title-medium">Contatti</span>
                              </a>
                            </li>
                            <li class="nav-item" *ngFor="let link of data?.links">
                              <a class="nav-link" href="javascript:void(0);" data-focus-mouse="false"
                                (click)="scrollTo(link.url)">
                                <span class="title-medium">{{
                                  link.title
                                  }}</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </aside>

      <section class="col-lg-9 it-page-sections-container border-light">
        <article id="descrizione" class="it-page-section anchor-offset richtext-wrapper"
          *ngIf="data?.place_long_description?.processed">
          <h2 class="mb-3">Descrizione</h2>
          <p [innerHTML]="sanitizeHtml(data?.place_long_description?.value)"></p>
        </article>
        <article id="servizi" class="it-page-section anchor-offset richtext-wrapper"
          *ngIf="data?.place_services?.processed">
          <h2 class="mb-3">Servizi presenti</h2>
          <p [innerHTML]="sanitizeHtml(data?.place_services?.processed)"></p>
        </article>
        <article id="accesso" class="it-page-section anchor-offset richtext-wrapper"
          *ngIf="data?.place_access_mode?.processed">
          <h2 class="mb-3">Modalità di accesso</h2>
          <p [innerHTML]="sanitizeHtml(data?.place_access_mode?.processed)"></p>
        </article>
        <article id="indirizzo" class="it-page-section anchor-offset richtext-wrapper" *ngIf="data?.place_address">
          <h2 class="mb-3">Indirizzo</h2>
          <div class="card-wrapper card-teaser-wrapper">
            <div class="card card-teaser shadow mt-3 rounded">
              <svg class="icon icon-success" aria-hidden="true">
                <use xlink:href="bootstrap-italia/dist/svg/sprites.svg#it-pin"></use>
              </svg>
              <div class="card-body">
                <h3 class="card-title h5">
                  <p>{{ data?.place_address }}, {{ data?.place_cap }}</p>
                </h3>
              </div>
            </div>
          </div>
          <div class="map-wrapper map-column mt-4">
            <app-map [showMap]="true" [markers]="markers"></app-map>
          </div>
        </article>
        <article id="orario" class="it-page-section anchor-offset richtext-wrapper" *ngIf="data?.place_time?.processed">
          <h2 class="mb-3 mt-5">Orario per il pubblico</h2>
          <p [innerHTML]="sanitizeHtml(data?.place_time?.processed)"></p>
        </article>
        <br />
        <app-contacts [data]="data?.place_contacts"></app-contacts>
      </section>
    </div>
  </div>
</main>